@if (isShowing) {
<div class="toast-container" [class.blocking]="options.infinite">
  @if (options.onlyLoadingIndicator) {
  <div id="loading-indicator" class="backdrop">
    <div class="threedotloader">
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
    </div>
  </div>
  }
  @if (!options.onlyLoadingIndicator) {
  <div class="backdrop" [ngClass]="{success: options.useSuccessStyle, error: options.useErrorStyle}">
    @if (options.iconName) {
    <div class="icon">
      <svg-helper [svgName]="options.iconName"></svg-helper>
    </div>
    }
    @if (options.loadingIndicatorAndMessage) {
    <div id="loading-indicator">
      <div class="threedotloader">
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
      </div>
    </div>
    }
    <div class="title">{{options.title}}</div>
    <div class="message" [innerHtml]="options.message"></div>
  </div>
  }
</div>
}
